import DebugLogger from '@frontend/app/features/DebugLogger';
import Tracker from '@frontend/app/features/Tracker';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';

export default class ConvertedWithTracking {
  static init() {
    const logger = new DebugLogger(false); // NB: enable logging by setting false => true
    if (CurrentUser.isSubscriber()) {
      return false;
    }

    const convertedWith = this.getCurrentPageIdentifier();
    if (convertedWith) {
      logger.log(
        `Storing converted_with for ${Tracker.defaultLifetimeInHours()} hours: ${convertedWith}`
      );
      const value = Tracker.get(this.getTrackingRefKey());
      if (undefined === value) {
        Tracker.store(this.getTrackingRefKey(), convertedWith);
      }
    }
  }

  // Returns an identifier for the current page if it is an article page.
  // Example: article-12345-article-title-with-up-to-50-maxchars
  //
  // Also this may include a reference to a ShareUrl-record
  // Example: shared-1-article-12345-article-title-with-up-to-50-maxchars
  //
  // For any other page an empty String is returned.
  static getCurrentPageIdentifier() {
    if (CurrentPage.isArticle()) {
      const pageIdentifierParts = [];
      if (CurrentPage.hasShareUrl()) {
        pageIdentifierParts.push('shared', CurrentPage.getShareUrl().id);
      }

      pageIdentifierParts.push(
        'article',
        CurrentPage.getArticleId(),
        CurrentPage.getArticleUrlSafeTitle()
      );
      return pageIdentifierParts.join('-').substr(0, 50);
    } else {
      const currentConvertedWith = this.getCurrentConvertedWith();
      if (currentConvertedWith.length > 0) {
        return currentConvertedWith;
      }

      return ['page', window.top.location.pathname.substring(1)]
        .join('-')
        .replaceAll('/', '-')
        .substr(0, 50);
    }
  }

  static getCurrentConvertedWith() {
    return Tracker.get(this.getTrackingRefKey()) || '';
  }

  static getTrackingRefKey() {
    return 'converted_with';
  }
}
